module.exports = __webpack_public_path__ + "img/teacher_9.f5984805.png";